import React, { useState } from "react";
import "./newcantactpage.css";
import banner1 from "../../assets/subbanner/executive-prepared-sign-contract.jpg";

import { useNavigate } from 'react-router-dom';

import ReCAPTCHA from 'react-google-recaptcha';



const ContactPage = () => {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [captchaVerified, setCaptchaVerified] = useState(true); // Temporarily true
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setError('');
        setSuccess('');
    };

    const validateForm = () => {
        const { name, email, phone, message } = formData;
        if (!name || !email || !message) return "Please complete all required fields.";
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) return "Invalid email format.";
        const phoneRegex = /^[0-9]{10}$/;
        if (!phoneRegex.test(phone)) return "Phone must be 10 digits.";
        return '';
    };

    const handleCaptchaChange = (value) => {
        setCaptchaVerified(!!value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationError = validateForm();
        if (validationError) {
            setError(validationError);
            return;
        }

        if (!captchaVerified) {
            alert("Please verify that you are not a robot.");
            return;
        }

        setLoading(true);

        try {
            const response = await fetch("https://nspp.in/php/send_email.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });

            const result = await response.json();
            if (result.status === "success") {
                navigate('/thankyou');
                setFormData({ name: '', email: '', phone: '', message: '' });
            } else {
                setError(result.message || "Something went wrong.");
            }
        } catch (err) {
            setError("Error connecting to server.");
        } finally {
            setLoading(false);
        }
    };
    return (

        <>
            <section>
                <div className="image-all-banner">
                    <img src={banner1} alt="About Us" className="image-bg-all" />
                    <div className="overlay-all-page">
                        <h2 className="fade-in-text">Contact</h2>
                    </div>
                </div>
            </section>
            <div className="contact-container">
                {/* Left Side - Info */}
                <div className="contact-info">
                    <h2>Interested in a project? Let's talk</h2>
                    <p className="phone">
                        📞 <a href="tel:+919500707033">+91 9500707033</a>
                    </p>

                    <h4>Headquarters</h4>
                    <p>
                        No:21, Vinayaga Nagar, <br />
                        Okkiyam,Thoraipakkam, <br />
                        Chennai - 600 097 <br />
                        {/* <a href="https://maps.google.com" target="_blank" rel="noreferrer">
                            Locate in Maps
                        </a> */}
                    </p>

                    <h4>Phone</h4>
                    
                     <a href="tel:+919500707033" style={{ textDecoration:"none", color:"#333"}}>+91 9500707033</a>
                        <br />
                

                  
                        <a href="tel:+914424581022" style={{ textDecoration:"none", color:"#333"}}>  044-24581022</a>
                 

                    {/* <h4>Fax</h4>
                    <p>+91 44 2434 6333</p> */}

                    <h4>Email</h4>
                    <p>
                        <a href="mailto:info@nspp.in">info@nspp.in</a>
                    </p>

                    <h4> Office Timing</h4>
                    <p>Mon - Fri: 09.30 am to 06.30 pm<br />
                        Sat: 9.30 am to 1.00 pm<br />
                        Sunday: Closed</p>


                </div>

                {/* Right Side - Form */}
                <div className="contact-form">
                    <h2>What we can help you with</h2>

                    <form onSubmit={handleSubmit}>

                        <div className="input-box">
                            <input
                                type="text"
                                name="name"
                                placeholder="Name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="input-box">
                            <input
                                type="text"
                                name="phone"
                                placeholder="Phone"
                                value={formData.phone}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="input-box">
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="input-box">
                            <textarea
                                name="message"
                                placeholder="Your Message..."
                                value={formData.message}
                                onChange={handleChange}
                                required
                            ></textarea>
                        </div>
                        <ReCAPTCHA
                            // sitekey="6LdyK74qAAAAAHior1ETtBZRJf6-78AZFgkPYKf3"
                            sitekey='6LeXcGorAAAAACdSVPL7n-JsQGj52OOs8aMvKkvr'
                            onChange={handleCaptchaChange}
                        />
                        <div className="button-box">
                            <button className="fillelipse" type="submit" disabled={loading}>
                                {loading ? 'Sending...' : 'Get Enquiry'}
                            </button>
                            {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
                            {success && <p style={{ color: 'green', marginTop: '10px' }}>{success}</p>}
                        </div>








                    </form>
                </div>
            </div>
        </>
    );
};

export default ContactPage;
